import { render, staticRenderFns } from "./Solicitud.vue?vue&type=template&id=98828ffc&"
import script from "./Solicitud.vue?vue&type=script&lang=js&"
export * from "./Solicitud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports